import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ScrollCollectSettingsResponse } from '../../services/types/api';

interface SettingsState {
  data: ScrollCollectSettingsResponse | null;
  loading: boolean;
  error: string | null;
  lastFetched: number | null;
}

const initialState: SettingsState = {
  data: null,
  loading: false,
  error: null,
  lastFetched: null,
};

const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    setSettingsLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
      if (action.payload) {
        state.error = null;
      }
    },
    setSettingsData: (state, action: PayloadAction<ScrollCollectSettingsResponse>) => {
      state.data = action.payload;
      state.loading = false;
      state.error = null;
      state.lastFetched = Date.now();
    },
    setSettingsError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
    },
    clearSettings: (state) => {
      state.data = null;
      state.loading = false;
      state.error = null;
      state.lastFetched = null;
    },
  },
});

export const {
  setSettingsLoading,
  setSettingsData,
  setSettingsError,
  clearSettings,
} = settingsSlice.actions;

export default settingsSlice.reducer;